import type {Badge} from '@/types/loyalty';
import {twx} from '@/utils/tailwindUtils';

import BadgeImage from '../../components/BadgeCard/BadgeImage';

type BadgeInProgressRowProps = {
    badge: Badge;
    className?: string;
};

/**
 * Compact horizontal preview row used on the main Badges page in the
 * "Badges in progress" section.
 */
const BadgeInProgressRow = ({badge, className}: BadgeInProgressRowProps) => {
    const {imageUrl, title, description} = badge;

    return (
        <div className={twx('flex items-center gap-2', className)}>
            <BadgeImage imageUrl={imageUrl} alt={title} size={64} />
            <div className='flex flex-col'>
                {title && <span className='font-bold text-16 leading-15'>{title}</span>}
                {description && <span className='text-14 text-romance leading-143'>{description}</span>}
            </div>
        </div>
    );
};

export default BadgeInProgressRow;
